import { render, staticRenderFns } from "./VisitRecordings.vue?vue&type=template&id=4e35c628&"
import script from "./VisitRecordings.vue?vue&type=script&lang=js&"
export * from "./VisitRecordings.vue?vue&type=script&lang=js&"
import style0 from "./VisitRecordings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports